import React from "react";
import styled from "styled-components";
import { Dialog, DialogTitle, DialogActions, DialogProps, Link } from "@material-ui/core";

import { t } from "js/i18n";
import { Button } from "js/Components/Button";
import { getStaticUrl } from "js/config";
import { defaultText, largeTitle } from "js/textStyles";
import { themeColors } from "js/react/sharedStyles";

const StyledDialog = styled(Dialog)`
    .MuiDialog-paper {
        padding: 20px 30px;
        border-radius: 5px;
        user-select: none;
        width: 550px;
    }
`;

const StyledDialogTitle = styled(DialogTitle)`
    &.MuiDialogTitle-root {
        padding: 0px;
    }

    h2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        ${largeTitle}
        font-size: 20px;
        letter-spacing: 0;
        color: #333;

        p {
            margin-top: 10px;
            ${defaultText}
            color: ${themeColors.mediumGray};
        }
    }
`;

const StyledDialogLogo = styled.img`
    width: 64px;
    height: 64px;
    margin-bottom: 20px;
`;

const StyledDialogActions = styled(DialogActions)`
    &.MuiDialogActions-root {
        padding: 0px;
        justify-content: flex-end;        
    }
`;

interface ShowRequestEditAccessSentSuccessfullyDialogProps extends DialogProps {
    closeDialog?: () => void;
    isRepeatRequest?: boolean;
}

const ShowRequestEditAccessSentSuccessfullyDialog = (props: ShowRequestEditAccessSentSuccessfullyDialogProps) => {
    const { closeDialog, isRepeatRequest } = props;

    const title = isRepeatRequest
        ? t("You have already requested edit access to this presentation")
        : t("Your edit request has been sent");

    return (
        <StyledDialog open={true} onClose={closeDialog}>
            <StyledDialogTitle>
                <StyledDialogLogo src={getStaticUrl("/images/auth/beautiful-branding.svg")} alt="logo" />
                {title}
                <p>{t("The presentation owner(s) have received your request. You’ll get a notification letting you know if your request was approved")}</p>
            </StyledDialogTitle>
            <StyledDialogActions>
                <Button unframed color={themeColors.ui_blue} onClick={closeDialog}>{t("Got it")}</Button>
            </StyledDialogActions>
        </StyledDialog>
    );
};

export default ShowRequestEditAccessSentSuccessfullyDialog;
